<script setup>
import {
  NSlider,
  NRadio,
  NSwitch,
  NCheckbox,
  NRadioGroup,
  NInputNumber,
  NSelect,
  NButton,
  useMessage,
  NPopover,
  NModal,
} from "naive-ui";
import { reqInitData, KEY_MAP } from "../baseData/system";
import { reportParams, mouseDevice } from "@/common";
import { ref, onMounted, watch, onUnmounted } from "vue";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { getCheckSum, sendReport, isLightMouse } from "../common/index.js";
import { language } from "@/hooks/util/i18n";
const main = useStore();
const message = useMessage();
const { device, init, languageValue, currentMouse } = storeToRefs(main);
const options = [
  { label: "1分钟", value: 1, _label: "1分钟" },
  { label: "2分钟", value: 2, _label: "2分钟" },
  { label: "3分钟", value: 3, _label: "3分钟" },
  // { label: "4分钟", value: 4 },
  { label: "5分钟", value: 5, _label: "5分钟" },
  { label: "10分钟", value: 10, _label: "10分钟" },
  { label: "20分钟", value: 20, _label: "20分钟" },
  { label: "30分钟", value: 30, _label: "30分钟" },
];
onUnmounted(() => {
  main.initData("");
  main.addDpi("");
});
const defaultValue = ref([]);
const value = ref(0);
const disabled = ref(true);
const moveRate = ref(0);
const circleValue = ref(1);
const scrollNumber = ref(1);
// const selectHeight = ref(0);
const sensorCheckbox = ref([false, false, false]);
const scrollDirect = ref(0);
const mode = ref(false);
const wakeMode = ref([false, true]);
const defaultTime = ref(10);
const angle = ref(0); // 角度旋转
// const changeLODheight = (value) => {
//   selectHeight.value = value;
// };
onMounted(async () => {
  if (device.value) {
    // 读取鼠标的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据
    await device.value.sendReport(reportId, reportData);
    if (localStorage.getItem(currentMouse.value + "Lock") == 1) {
      mouseLeftLock.value = false;
    }
  }
});
onUnmounted(() => {
  main.initData("");
});
const currentDpi = ref(0);
watch(init, (newValue, oldValue) => {
  if (defaultValue.value.length || !newValue) {
    // console.log("已经有初始值");
    return;
  }

  const arr = newValue.split(" ");
  currentDpi.value = Number(arr[6]);
  const num = mouseDevice() === "v2" ? 8 : 0;
  defaultValue.value = [num === 8 ? "00 04 00 a5 02" : "00 04 00 ad 02"].concat(
    arr.slice(5, arr.length - 1)
  );
  const array = Object.keys(KEY_MAP);

  for (let i = 0; i < array.length; i++) {
    if (KEY_MAP[array[i]].toLowerCase() === arr[5].toLowerCase()) {
      for (let j = 0; j < 3; j++) {
        if (array[i][j] === "0") {
          sensorCheckbox.value[j] = false;
        } else {
          sensorCheckbox.value[j] = true;
        }
      }
      scrollDirect.value = Number(array[i][3]);
      mode.value = array[i][4] === "0" ? false : true;
      break;
    }
  }

  if (Number(arr[6]) >= 4) {
    mode.value = true;
  }

  // 设置LOD高度
  // selectHeight.value = arr[37] === "01" ? 1 : 0;
  // 设置延迟时间
  scrollNumber.value = parseInt(arr[48 - num], 16);
  // 设置休眠时间
  defaultTime.value =
    (parseInt(arr[44 - num], 16) + parseInt(arr[45 - num], 16) * 256) / 60;
  // 设置唤醒方式
  switch (arr[39 - num]) {
    case "00":
      wakeMode.value = [true, true];
      break;
    case "02":
      wakeMode.value = [true, false];
      break;
    case "01":
      wakeMode.value = [false, true];
      break;
    case "03":
      wakeMode.value = [false, false];
      break;
  }

  // 光微动鼠标
  if (isLightMouse() || mouseDevice() === "v2") {
    const angleValue = parseInt(arr[38 - num], 16);
    if (angleValue >= 0 && angleValue <= 44) {
      angle.value = angleValue;
    } else {
      angle.value = parseInt("ffffff" + arr[38 - num], 16) - Math.pow(2, 32);
    }
    isRotate.value = angle.value === 0 ? false : true;
  }
});
const setting = () => {
  // 设置鼠标LOD高度的字节数据
  // defaultValue.value[33] = selectHeight.value === 0 ? "02" : "01";
  const num = mouseDevice() === "v2" ? 8 : 0;
  // 设置性能方向高速模式
  let key = "";
  for (let i = 0; i < sensorCheckbox.value.length; i++) {
    key += Number(sensorCheckbox.value[i]);
  }
  key += scrollDirect.value;
  key += Number(mode.value);
  // console.log("key", key);
  defaultValue.value[1] = KEY_MAP[key];
  // 设置唤醒方式 ['03', '02', '01', '00']
  if (wakeMode.value[0] && wakeMode.value[1]) {
    defaultValue.value[35 - num] = "00";
  } else if (wakeMode.value[0]) {
    defaultValue.value[35 - num] = "02";
  } else if (wakeMode.value[1]) {
    defaultValue.value[35 - num] = "01";
  } else {
    defaultValue.value[35 - num] = "03";
  }
  // 设置按键延迟响应(毫秒)
  defaultValue.value[44 - num] = scrollNumber.value
    .toString(16)
    .padStart(2, "0");

  // 设置休眠时间的字节数据
  defaultValue.value[40 - num] = ((defaultTime.value * 60) % 256)
    .toString(16)
    .padStart(2, "0");
  defaultValue.value[41 - num] = Math.floor((defaultTime.value * 60) / 256)
    .toString(16)
    .padStart(2, "0");
  defaultValue.value[42 - num] = defaultValue.value[40 - num];
  defaultValue.value[43 - num] = defaultValue.value[41 - num];

  // 光微动鼠标 设置角度偏移
  if (isLightMouse() || mouseDevice() === "v2") {
    defaultValue.value[34 - num] = (Math.pow(2, 32) + Number(angle.value))
      .toString(16)
      .slice(-2);
  }

  const str = defaultValue.value.join("");
  const value = str + getCheckSum(str);
  try {
    sendReport(value);
    message.success("设置成功!");
  } catch {
    message.error("设置失败,请检查设备是否连接");
  }
};

// onMounted(() => {
//   if (document.getElementById("slider")) {
//     document.getElementById("slider").style.zoom = 1 / document.body.style.zoom;
//   }
// });
const angleMouse = ref();
const isRotate = ref(true);
watch(angle, (newValue) => {
  const value = Number(newValue);
  if (!newValue) {
    angle.value = 0;
  }
  if (value >= 45) {
    angle.value = 44;
  }
  if (value < -44) {
    angle.value = -44;
  }
  if (angleMouse.value) {
    angleMouse.value.style.transform = `rotate(${newValue}deg)`;
  }
});
const onAngleSwitch = (value) => {
  if (!value) {
    angle.value = 0;
  }
};
const mouseLeftLock = ref(true);
const showModal = ref(false);
const leftLockUpdate = (value) => {
  if (!value) {
    showModal.value = true;
  } else {
    mouseLeftLock.value = value;
    localStorage.removeItem(currentMouse.value + "Lock");
  }
};
const onPositiveClick = () => {
  mouseLeftLock.value = false;
  localStorage.setItem(currentMouse.value + "Lock", 1);
};
</script>

<template>
  <div class="system">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top">
      <n-popover>
        <template #trigger>
          <img
            src="@/images/system.png"
            alt=""
            style="cursor: pointer; margin-right: 48px"
          />
        </template>
        <span>{{ language[languageValue]["性能设置"] }}</span>
      </n-popover>

      <span class="middle">{{ language[languageValue]["性能设置"] }}</span>
    </div>
    <div class="linear"></div>
    <div style="box-sizing: border-box; position: relative">
      <div class="system_setting">
        <!-- 角度旋转 光微动版本具备 -->
        <div v-if="isLightMouse() || mouseDevice() === 'v2'">
          <div style="display: flex; justify-content: space-between">
            <div>
              <span class="title">
                {{ language[languageValue]["旋转"] }}
              </span>
              <n-popover trigger="hover">
                <template #trigger>
                  <img
                    src="@/images/rate-icon2.png"
                    alt=""
                    style="
                      cursor: pointer;
                      vertical-align: middle;
                      margin-top: -3px;
                      margin-left: 4px;
                    "
                  />
                </template>
                <span>{{
                  language[languageValue][
                    "根据抓握方式调整鼠标传感器角度,即使在鼠标倾斜时也能实现精确的水平移动"
                  ]
                }}</span>
              </n-popover>
            </div>

            <n-switch
              v-model:value="isRotate"
              size="small"
              style="
                margin-right: 10px;
                background-color: #ccc;
                border-radius: 7px;
                margin-top: 4px;
              "
              @update-value="onAngleSwitch"
            />
          </div>
        </div>
        <div class="angle" v-if="isLightMouse() || mouseDevice() === 'v2'">
          <img src="@/images/angleMouse.png" alt="" ref="angleMouse" />
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            margin: 2px 0 10px -20px;
          "
          v-if="isLightMouse() || mouseDevice() === 'v2'"
        >
          <n-input-number
            :disabled="!isRotate"
            class="angle_input"
            v-model:value="angle"
            placeholder=""
            size="tiny"
            :show-button="false"
            style="
              width: 40px;
              background: linear-gradient(
                90deg,
                rgba(37, 91, 103, 1),
                rgba(37, 91, 103, 1)
              );

              border-radius: 3px;
              text-align: center;
            "
          >
          </n-input-number>
        </div>

        <div style="width: 90%" v-if="isLightMouse() || mouseDevice() === 'v2'">
          <n-slider
            :disabled="!isRotate"
            class="angle_slider"
            :tooltip="false"
            :min="-44"
            :max="44"
            id="slider"
            v-model:value="angle"
          ></n-slider>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-left: -5px;
            "
          >
            <span>-44</span>
            <span>0</span>
            <span>44</span>
          </div>
        </div>

        <div class="line" v-if="isLightMouse() || mouseDevice() === 'v2'"></div>

        <div>
          <div style="margin-bottom: 15px">
            <span class="title">{{
              language[languageValue]["Sensor画线性能"]
            }}</span>
            <n-popover trigger="hover">
              <template #trigger>
                <img
                  src="@/images/rate-icon2.png"
                  alt=""
                  style="
                    cursor: pointer;
                    vertical-align: middle;
                    margin-top: -3px;
                    margin-left: 4px;
                  "
                />
              </template>
              <span> 
                Sensor画线性能<br/>
                [纹波控制]<br/>
                传感器在DPI值大于9000时会有波纹状,改善这个波纹状,<br/>
                DPI值小于9000DPI时可无视此参数设置<br/>
                [直线修正]<br/>
                修正一定角度的偏移为直线<br/>
                [Motion Sync]<br/>
                传感器刷新周期的准确性和传感器移动数据的离散性
              </span>
            </n-popover>
          </div>
          <div>
            <n-checkbox v-model:checked="sensorCheckbox[0]">
              {{ language[languageValue]["波纹控制"] }}
            </n-checkbox>
          </div>
          <div style="margin: 15px 0">
            <n-checkbox v-model:checked="sensorCheckbox[1]">{{
              language[languageValue]["直线修正"]
            }}</n-checkbox>
          </div>
          <div style="margin-bottom: 15px">
            <n-checkbox v-model:checked="sensorCheckbox[2]">{{
              language[languageValue]["Motion Sync开启"]
            }}</n-checkbox>
          </div>
        </div>
        <div class="line"></div>
        <div class="scroll-setting" style="margin-bottom: 15px">
          <div class="title" style="margin-bottom: 10px">
            {{ language[languageValue]["滚动方向设置"] }}
          </div>

          <n-radio-group v-model:value="scrollDirect" name="radiogroup">
            <n-radio :value="0">{{ language[languageValue]["正向"] }}</n-radio>
            <n-radio :value="1">{{ language[languageValue]["反向"] }}</n-radio>
          </n-radio-group>
        </div>
        <div class="line"></div>
        <div>
          <div style="display: flex; justify-content: space-between">
            <span class="title">{{ language[languageValue]["高速模式"] }}</span>
            <n-switch
              :disabled="currentDpi <= 3 ? false : true"
              v-model:value="mode"
              size="small"
              style="margin-right: 10px; --n-rail-color: #ccc; margin-top: 4px"
            />
          </div>
          <div class="desc">
            {{
              language[languageValue][
                "注：有利于提高性能，但会增加功耗，无法和2K/4K/8K同时开启"
              ]
            }}
          </div>
        </div>
        <div class="line" style="margin-top: 15px"></div>
        <div v-if="!isLightMouse()">
          <div style="display: flex; justify-content: space-between">
            <span style="flex: 2" class="title">{{
              language[languageValue]["按键延迟响应（毫秒）"]
            }}</span>
            <n-input-number
              style="width: 90px"
              v-model:value="scrollNumber"
              size="tiny"
              :min="0"
              :max="20"
            />
          </div>
        </div>
        <div class="line" style="margin-top: 15px" v-if="!isLightMouse()"></div>
        <div v-if="!isLightMouse()">
          <div style="margin: 15px 0" class="title">
            {{ language[languageValue]["唤醒方式"] }}
          </div>
          <div style="display: flex; justify-content: space-between">
            <n-checkbox v-model:checked="wakeMode[0]">{{
              language[languageValue]["移动唤醒"]
            }}</n-checkbox>
            <n-checkbox v-model:checked="wakeMode[1]">{{
              language[languageValue]["按键唤醒"]
            }}</n-checkbox>
          </div>
        </div>
        <div class="line" style="margin-top: 15px" v-if="!isLightMouse()"></div>
        <div>
          <div style="display: flex; justify-content: space-between">
            <span style="flex: 2" class="title">{{
              language[languageValue]["休眠时间"]
            }}</span>
            <n-select
              placeholder="选择时间"
              :options="
                options.map((item) => ({
                  ...item,
                  label: language[languageValue][item.label],
                }))
              "
              style="width: 90px"
              v-model:value="defaultTime"
              size="tiny"
            />
          </div>
        </div>
        <div class="line" style="margin-top: 15px"></div>
        <div>
          <div style="display: flex; justify-content: space-between">
            <span class="title">{{
              language[languageValue]["鼠标左键锁"]
            }}</span>

            <n-switch
              :value="mouseLeftLock"
              @update-value="leftLockUpdate"
              size="small"
              style="margin-right: 10px; --n-rail-color: #ccc; margin-top: 4px"
            />
          </div>
        </div>
      </div>
    </div>
    <n-modal
      v-model:show="showModal"
      :mask-closable="false"
      preset="dialog"
      content="修改鼠标左键可能会导致无法确认,是否要进行解锁"
      positive-text="是"
      negative-text="否"
      @positive-click="onPositiveClick"
    />
    <div class="btn" @click="setting">
      <n-button type="info">{{ language[languageValue]["确认设置"] }}</n-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.system {
  font-family: PingFang;
  width: 288px;

  color: #fff;
  position: relative;
  .angle {
    // position: relative;
    display: flex;
    justify-content: center;
    margin-left: -20px;
    background: url("@/images/line.png") no-repeat;
    background-position: 65px;
    img {
      transform: rotate(0deg);
    }
  }
  // .angle_input {
  //   /deep/ .n-input__input-el {
  //     color: #fff !important;
  //   }
  // }
  .angle_slider {
    /deep/ .n-slider-rail__fill {
      background-color: #fff;
    }
  }
  .scroll-setting {
    /deep/ .n-radio__label {
      color: #637077;
      font-weight: bold;
      font-size: 14px;
    }
    /deep/ .n-radio--checked .n-radio__label {
      color: #fff;
    }
  }
  .desc {
    font-family: PingFang;
    font-weight: 500;
    font-size: 11px;
    color: #637077;
    margin-top: 13px;
  }
  .word {
    font-weight: bold;
    font-size: 14px;
    color: #fff;
  }
  .title {
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
  .top {
    display: flex;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 16px;

    height: 64px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    padding: 0 18px 0 26px;
    .middle {
      position: relative;
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
    }
  }
  .header {
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    text-align: center;
    background-color: #15211d;
  }
  .system_setting {
    height: 600px;
    // overflow: hidden;
    overflow: auto;
    overflow-x: hidden;
    padding: 23px 13px 24px 19px;
    background: linear-gradient(
      90deg,
      rgba(19, 52, 71, 0.22),
      rgba(2, 12, 22, 0.22)
    );
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    /deep/ .n-checkbox__label {
      color: #637077;
      font-weight: bold;
      font-size: 14px;
    }
    /deep/ .n-checkbox--checked .n-checkbox__label {
      font-weight: bold;
      font-size: 14px;
      color: #fff;
    }
  }
  /deep/ .n-radio__label,
  /deep/ .n-checkbox__label {
    color: #fff;
  }
  .selectedIcon::before {
    position: absolute;
    left: -50px;
    content: "";
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: #fff;
  }
  .btn {
    position: absolute;
    right: 10px;
    margin-top: 20px;
    /deep/.n-button {
      background: linear-gradient(
        90deg,
        rgba(19, 52, 71, 0.22),
        rgba(2, 12, 22, 0.22)
      );
    }
  }
}
.line {
  width: 260px;
  height: 2px;
  background: linear-gradient(90deg, #000c1a, #255b67);
  margin-left: -8px;
  margin-bottom: 15px;
}
</style>
